import React from "react";

// reactstrap components
import { Button, Container } from "reactstrap";

function EducationalSolutionsHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth < 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div
        style={{
          backgroundImage:
            "url(" + require("assets/img/Teachi.png") + ")",
        }}
        className="page-header"
        data-parallax={true}
        ref={pageHeader}
      >
        <div className="filter" />
        <Container>
          <div className="motto text-center">
            <h1>Educational Solutions</h1>
            <h3>
              Innovative technology solutions including AI-powered learning assistants, 
              interactive platforms, and specialized educational tools.
            </h3>
            <br />
            <Button
              href="https://book.ms/b/ClassInquiries@robotyze.org"
              className="btn-round mr-1"
              color="neutral"
              target="_blank"
              outline
            >
              <i className="fa fa-lightbulb-o" />
              Learn More
            </Button>
            <Button 
              href="#solutions"
              className="btn-round" 
              color="neutral" 
              type="button" 
              outline
            >
              <i className="fa fa-arrow-down" />
              View Solutions
            </Button>
          </div>
        </Container>
      </div>
    </>
  );
}

export default EducationalSolutionsHeader;